export default __webpack_public_path__ + "static/media/GlacialIndifference.1b433849.ttf";